import { hasData } from "./hasData"

export function getTimestamp(n) {
    if (hasData(n) && n?.toString() !== '0') {
      return n
    }
    return 0
  }